export const types = {
    login: '[auth] Autenticacion',
    logout: '[auth] Logout'
}